import { render } from "./Product.vue?vue&type=template&id=c5053be4&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=c5053be4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c5053be4"

export default script